/**
 * @desc Whether `path` is an admin page. On the platform build the global nav column shows the
 * admin tree there by default (add-ario-identity-and-authoring-round-3 D3); "Admin →" and
 * "← Back" swap the list on any page without navigating (`components/GlobalNav/nav-mode.ts`).
 */
export const isAdminPath = (path: string): boolean =>
  path === '/admin' || path.startsWith('/admin/');
